import { render } from "./ChatActionMenu.vue?vue&type=template&id=c5e29fd4"
import script from "./ChatActionMenu.vue?vue&type=script&lang=js"
export * from "./ChatActionMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/delano/projects/wp-dev/wp-content/plugins/wp-sam-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__